import { InputGroup, InputLeftAddon, Icon, Box, Grid } from '@chakra-ui/react';
import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IconFilter } from 'assets/icons';
import RangePicker from 'components/RangePicker';
import ReactSelect from 'components/ReactSelect';
import SearchField from 'components/SearchField';
import { filterOptions } from 'containers/CompanySettings/shared/options';
import { useCompanyInfo } from 'store/useUserStore';

interface IFilterGroupProps {
  handleDateChange: (selectedDates: any) => void;
  handleActionChange?: (selectedValue: ILabelValueOptions) => void;
  handleSearchInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FilterGroup: React.FC<IFilterGroupProps> = ({
  handleActionChange,
  handleSearchInputChange,
  handleDateChange,
}) => {
  const { t } = useTranslation(['common', 'companySettings']);

  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  const companyInfo = useCompanyInfo();

  const handleChange = (dates: any) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    handleDateChange(dates);
  };

  return (
    <Grid
      templateColumns={{ base: '1fr', sm: 'repeat(2, 1fr)', lg: '210px 300px 1fr' }}
      gap="4"
      sx={{ '.valueContainerWrapper': { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } }}
    >
      <InputGroup maxWidth={{ lg: '210px' }}>
        <InputLeftAddon children={<Icon as={IconFilter} height="20px" width="20px" />} px="2" />
        <ReactSelect
          options={filterOptions}
          size="md"
          variant="outline"
          fontSize="sm"
          isClearable
          isSearchable
          placeholder={t('companySettings:filterBy')}
          formatOptionLabel={(data: any) => t(data.label)}
          onChange={handleActionChange}
        />
      </InputGroup>
      <Box sx={{ '& > div': { m: 0 } }}>
        <RangePicker
          selected={startDate}
          startDate={startDate}
          endDate={endDate}
          onChange={handleChange}
          dateFormat={companyInfo?.companyDateFormat}
        />
      </Box>

      <Box ml="auto" maxWidth={{ lg: '350px' }} width="100%">
        <SearchField
          inputProps={{
            placeholder: 'Search Logs',
            onChange: handleSearchInputChange,
          }}
        />
      </Box>
    </Grid>
  );
};

export default memo(FilterGroup);
